var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.loading)?_c('Loading'):_vm._e(),_vm._l((_vm.items),function(item){return _c('Item',{key:item.id,attrs:{"item":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }